/*jshint esversion: 6 */
import React, { Component } from 'react';
import '../css/ImageSlider.css';
import '../css/utils.css';
// import pic1 from './images/slide_images/img_nature_wide.jpg';
// import pic2 from './images/slide_images/img_fjords_wide.jpg';
// import pic3 from './images/slide_images/img_mountains_wide.jpg';

class Dot  extends Component {
  constructor(props){
    super(props);
    this.handleDotClick = this.handleDotClick.bind(this);
  }
  handleDotClick(e){
    logm("inner this.props", this.props )
    this.props.onDotClick(this.props.dotIndex);
  }
  render(){
    return (
      <span 
        className={this.props.classN} 
        onClick = {this.handleDotClick}
      >
      </span>
    );

  }
}

class DotRow extends Component {
  constructor(props){
    super(props);
    this.onhandleDotClick = this.onhandleDotClick.bind(this);
  }
  onhandleDotClick(dotIndex){
    this.props.onDotClick(dotIndex);
  }
  render(){
    const nrOfDots = this.props.amount;
    const dotsRow = [];
    for(let i = 0; i < nrOfDots; i++){
      let clName = "dot "
      clName += (this.props.slideIndex === i)? "dot_white" : "dot_regular";
      dotsRow.push(
        <Dot 
          key = {i}
          classN = {clName}
          dotIndex = {i}
          onDotClick = {this.onhandleDotClick}
        />
      );
    }
    return dotsRow;
  }
}

class ImageSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex : 0,
      slideImages: [],
    };
    this.timer = this.timer.bind(this);
    this.nextImage = this.nextImage.bind(this);
    this.prevImage = this.prevImage.bind(this);
    this.dotClick = this.dotClick.bind(this);
  }

  nextImage(){
    if(this.state.slideIndex >= this.props.sliderImages.length-1){
      return;
    }
    this.setState(prevState => ({
      slideIndex: prevState.slideIndex+1})
    );
  }
  prevImage(){
    if(this.state.slideIndex <= 0){
      return;
    }
    this.setState(prevState => ({
      slideIndex: prevState.slideIndex-1})
    );
  }
  dotClick(dotIndex){
      logm("dot event", dotIndex);
      this.setState({slideIndex: dotIndex});
  }

 

  componentDidMount() {
    var intervalId = setInterval(this.timer, 3000);
    // store intervalId in the state so it can be accessed later:
    this.setState({intervalId: intervalId});
  }
  componentWillUnmount() {
    //clearInterval(this.interval);
    clearInterval(this.state.intervalId);
  }

  timer() {
    if(this.state.slideIndex === this.props.sliderImages.length-1){
      this.setState({ slideIndex: 0 });
    }
    else{
      this.setState({ slideIndex: this.state.slideIndex + 1 });
    }
  }


    render() {
      const sliderImages = this.props.sliderImages;
      //this.setState({slideImages : sliderImages});
      const picIndex = this.state.slideIndex;
      const pic = sliderImages[picIndex];//this.state.slideImages[picIndex];
      return (
        <div className="slideImageContainer">
          <img className="mySlides" src={pic} alt="pilt"/>
          <div className="arrow_container" >
            <div className="arrow arrow_right" onClick={this.nextImage}>&#10095;</div>
            <div className="arrow arrow_left" onClick={this.prevImage}>&#10094;</div>
          </div>
          <div className="dot_row">
            <DotRow  
                amount = {sliderImages.length}
                slideIndex = {this.state.slideIndex}
                onDotClick = {this.dotClick}
              />
          </div>
        </div>
      );
    }
  }
  
  function logm(mess, val){
    console.log(mess, val);
  }
  export default ImageSlider;


// WEBPACK FOOTER //
// ./src/Templates/ImageSlider.js